export enum OgTypeEnum {
    Website = 'website',
    Article = 'article',
}
